
import React from 'react';
import { Button } from '@/components/ui/button';
import { ReviewsList } from '@/components/admin/reviews/ReviewsList';
import { CreateCustomReviewDialog } from '@/components/admin/reviews/CreateCustomReviewDialog';
import { Plus } from 'lucide-react';
export function ReviewsContent() {
  const [isCreateDialogOpen, setIsCreateDialogOpen] = React.useState(false);
  return <div className="p-6 space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">Reviews</h1>
        <Button onClick={() => setIsCreateDialogOpen(true)} className="flex items-center gap-2">
          <Plus className="h-4 w-4" />
          Add Review
        </Button>
      </div>
      
      <ReviewsList />
      
      <CreateCustomReviewDialog open={isCreateDialogOpen} onOpenChange={setIsCreateDialogOpen} />
    </div>;
}
